import { styled } from "@mui/material";
import Tab from "@mui/material/Tab";

interface StyledTabProps {
  tabsType: "primary" | "secondary";
  disabled?: boolean;
}

const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== "tabsType",
})<StyledTabProps>`
  min-width: 0;
  text-transform: none;
  color: ${({ theme }) => theme.wsc.palette.neutral[200]};
  padding: ${({ theme, tabsType }) =>
    tabsType === "primary"
      ? `${theme.wsc.spacing[1]} ${theme.wsc.spacing[3]}`
      : theme.wsc.spacing[1]};
  ${({ theme, tabsType }) =>
    theme.wsc.typography[tabsType === "primary" ? "header5" : "body1bold"]};

  &.Mui-selected {
    color: ${({ theme, tabsType }) =>
      tabsType === "primary"
        ? theme.wsc.palette.primary[300]
        : theme.wsc.palette.neutral[100]};
  }

  &:hover:not(.Mui-selected) {
    color: ${({ theme, tabsType }) =>
      tabsType === "primary"
        ? theme.wsc.palette.primary[100]
        : theme.wsc.palette.neutral[0]};

    ::before {
      background-color: ${({ theme, tabsType }) =>
        tabsType === "primary"
          ? theme.wsc.palette.primary[100]
          : theme.wsc.palette.neutral[0]};
    }
  }

  &.Mui-disabled {
    color: ${({ theme }) => theme.wsc.palette.neutral[400]};

    &.Mui-selected {
      color: ${({ theme }) => theme.wsc.palette.neutral[300]};

      ::before {
        background-color: ${({ theme }) => theme.wsc.palette.neutral[300]};
      }
    }
  }

  &.Mui-selected,
  &:hover {
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: ${(props) => (props.tabsType === "primary" ? "4px" : "2px")};
      bottom: 0;
      border-radius: ${(props) => props.theme.wsc.radius.m};
      z-index: ${(props) => (props.disabled ? 1 : 0)};
    }
  }

  .material-symbols-outlined {
    margin-bottom: ${(props) => props.theme.wsc.spacing[0]};
  }
`;

export default StyledTab;
